<template>
<div class="nodata-com">
  <div :style="{'paddingTop':Top}"><img :src="nodata_img" alt :width="ws" :height="hs"/></div>
  <div class="text">
    <span>{{ $t(nodata_ind) }}</span>
    <span><br />{{ $t( nodataTow) }}</span>
  </div>
</div>
</template>

<script>
  export default {
    props:{
      nodata_ind:{
        type:String,
        default:'newHome.NoMore'
      },
      nodataTow:{
        type:String,
        default:''
      },
      nodata_img:{
        type:String,
        default:require('./img/empty.png')
      },
      ws:{
        type:String,
        required:false
      },
      hs:{
        type:String,
        required:false
      },
      Top:{
        type:String,
        default:'80px'
      },
    },
  }

</script>
<style lang="scss" scoped>
.nodata-com{
  background: rgba(255, 255, 255, 0.098);
  width:100%;
  text-align: center;
  padding-bottom:50px;
  // box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
	// border-radius: 5px;
  .text{ margin-top:20px;color:#fff;-webkit-text-stroke: .5px;}
}
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/NoData/index.vue